import { type RefObject, useEffect } from "react";


export function useDeepLinkScroll(
  ref: RefObject<HTMLElement | null>,
  target: string | null | undefined
) {
  useEffect(() => {
    if (!target) return;
    const frame = requestAnimationFrame(() => {
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    return () => cancelAnimationFrame(frame);
  }, [ref, target]);
}
